module.exports = __webpack_public_path__ + "2fe5b882478e5f988caca8eac882b2e3.pdf";